import React from "react";

// Banner đăng ký khóa học đã được xóa theo yêu cầu

const Header = ({ title }) => {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
        width: "100%",
        minHeight: "120px",
        display: "flex",
        alignItems: "center",
        padding: "30px 65px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "start",
          color: "white",
          width: "70%",
          gap: "15px",
        }}
      >
        <span style={{ fontSize: "28px", fontWeight: "500" }}>{title}</span>
      </div>
    </div>
  );
};
export default Header;
